import CityPageFactory from '../CityPage';

export default CityPageFactory({
  locationName: 'Los Angeles',
  locationParam: 'Los Angeles, CA',
  heroImageFilename: 'city-los-angeles.webp',
  heroImageAltText:
    'daycare teacher at an on-demand child care location in Los Angeles, CA lovingly watching the children in her care play with toy animals',
  lat: 34.0536909,
  lng: -118.242766,
});
